/** Source d'avantage en nature (immobilisation ou véhicule de flotte). */
export type AvantageNatureEntry = {
  salarie_id?: string;
  montant_mensuel: number;
  actif: boolean;
};

/**
 * Agrège les avantages en nature mensuels par salarié
 * (immobilisations actives + véhicules en service).
 */
export function avantageNatureParSalarie(
  entries: readonly AvantageNatureEntry[],
): Map<string, number> {
  const map = new Map<string, number>();
  for (const entry of entries) {
    if (!entry.actif || !entry.salarie_id) continue;
    const montant = Number(entry.montant_mensuel) || 0;
    if (montant <= 0) continue;
    map.set(entry.salarie_id, (map.get(entry.salarie_id) ?? 0) + montant);
  }
  return map;
}

/** Immobilisation avec affectation salarié et AN mensuel. */
export function avantagesFromImmobilisations(
  immos: ReadonlyArray<{ salarie_id?: string; an_mensuel?: number; statut?: string }>,
): AvantageNatureEntry[] {
  return immos.map((immo) => ({
    salarie_id: immo.salarie_id,
    montant_mensuel: Number(immo.an_mensuel) || 0,
    actif: immo.statut === 'active' && Boolean(immo.salarie_id),
  }));
}

/** Véhicule de flotte avec affectation salarié. */
export function avantagesFromVehicules(
  vehicules: ReadonlyArray<{
    salarie_id?: string;
    avantage_nature_mensuel?: number;
    statut?: string;
  }>,
): AvantageNatureEntry[] {
  return vehicules.map((v) => ({
    salarie_id: v.salarie_id,
    montant_mensuel: Number(v.avantage_nature_mensuel) || 0,
    actif: v.statut === 'En service' && Boolean(v.salarie_id),
  }));
}
